export const DEFAULT_STATUS_META = {
  label: 'Unknown',
  description: 'Status information about this policy.'
};

export const normalizeStatusKey = (statusRaw = '') => (
  statusRaw
    ? statusRaw
        .toString()
        .trim()
        .toLowerCase()
        .replace(/[_-]+/g, ' ')
        .replace(/\s+/g, ' ')
    : ''
);

const formatStatusLabel = (statusRaw) => {
  if (!statusRaw) return DEFAULT_STATUS_META.label;
  return statusRaw
    .toString()
    .trim()
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .toUpperCase();
};

const INFORCE_META = {
  label: 'INFORCE',
  description: 'Your policy is active.'
};

const MATURED_META = {
  label: 'MATURITY',
  description: 'Your policy has matured and is awaiting claim.'
};

const STATUS_DESCRIPTION_MAP = {
  'active': {
    ...INFORCE_META,
    label: 'INFORCE'
  },
  'inforce': {
    ...INFORCE_META,
    label: 'INFORCE'
  },
  'inforce policy': {
    ...INFORCE_META,
    label: 'INFORCE'
  },
  'inforce policy status': {
    ...INFORCE_META,
    label: 'INFORCE'
  },
  'inactive': {
    label: 'INACTIVE',
    description: 'This policy is not currently active.'
  },
  'maturity': MATURED_META,
  'matured': MATURED_META,
  'expired': {
    label: 'EXPIRED',
    description: 'The policy period has ended.'
  },
  'paid up': {
    label: 'PAID UP',
    description: 'Premium payments stopped after at least twenty-four months; coverage continues with reduced benefits.'
  },
  'paidup': {
    label: 'PAID UP',
    description: 'Premium payments stopped after at least twenty-four months; coverage continues with reduced benefits.'
  },
  'surrendered': {
    label: 'SURRENDERED',
    description: 'The policy was ended early and the cash value was paid out.'
  },
  'moved to das': {
    label: 'MOVED TO DAS',
    description: 'Funds were transferred to a Deposit Administration Scheme to earn higher returns.'
  },
  'moved to deposit administration scheme': {
    label: 'MOVED TO DAS',
    description: 'Funds were transferred to a Deposit Administration Scheme to earn higher returns.'
  },
  'surrendered notified': {
    label: 'SURRENDERED NOTIFIED',
    description: "We've received notice to surrender the policy after premium deductions stop."
  },
  'surrender notified': {
    label: 'SURRENDERED NOTIFIED',
    description: "We've received notice to surrender the policy after premium deductions stop."
  },
  'surrenderdd notified': {
    label: 'SURRENDERED NOTIFIED',
    description: "We've received notice to surrender the policy after premium deductions stop."
  }
};

export const getStatusMeta = (statusRaw) => {
  const normalized = normalizeStatusKey(statusRaw);
  if (!normalized) {
    return DEFAULT_STATUS_META;
  }
  return STATUS_DESCRIPTION_MAP[normalized] || {
    label: formatStatusLabel(statusRaw),
    description: DEFAULT_STATUS_META.description
  };
};
